
export enum ThirdPartyType
{
    Facebook = 1,
    Instagram = 2,
    Google = 3,
    Strava = 4,
    Polar = 5,
}